import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const NewCampaign = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.25 1.25V9.25"
          stroke="#3C3B37"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M21.25 5.25H29.25"
          stroke="#3C3B37"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M16.25 5.25H4.25C2.593 5.25 1.25 6.593 1.25 8.25V26.25C1.25 27.907 2.593 29.25 4.25 29.25H22.25C23.907 29.25 25.25 27.907 25.25 26.25V14.25"
          stroke="#3C3B37"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </svg>
    </SvgIcon>
  )
}

export default NewCampaign
